module.exports = __WEBPACK_EXTERNAL_MODULE__bopen_leaflet_area_selection_dist_index_css__;